module.exports = __webpack_public_path__ + "static/media/iconVisit.bbba95be.svg";